@if (item().external) {
  <!-- External Links -->
  <a target="_blank" [href]="item().url" [style]="itemStyles()">{{
    item().label
  }}</a>
} @else {
  <!-- Internal Links -->
  <a
    [style]="itemStyles()"
    [fragment]="item().fragment"
    [routerLink]="(!untienotsId ? '../' : '') + item().url"
    >{{ item().label }}</a
  >
}
